<div class="div-container" fxLayout="column" fxLayoutGap="20px">
  <span fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="40px">
    <span class="heading medium" ngClass.xs="heading xs medium">{{'Evacuation Alert'|transloco}}</span>
    <img alt="close" style="cursor: pointer;padding-top: 3px;" (click)="onClose()" height="22" width="22"
      src="assets/icons/dialogclose.svg" />
  </span>
  <mat-dialog-content ngStyle.xs="max-height: 55vh">
    <div *ngIf="isLoading" fxLayout="row" fxLayoutAlign="center center">
      <mat-spinner mode="indeterminate" color="primary" diameter="40"></mat-spinner>
    </div>
    <div *ngIf="!isLoading && noData" fxLayout="row" fxLayoutAlign="center center">
      <span class="text-large-light regular">{{"no_data_found"|transloco}}</span>
    </div>
    <div *ngIf="!isLoading && !noData" fxLayout="column" fxLayoutGap="15px">
      <span dir="auto"
        style="white-space: initial;">{{'Note: For all the countries in this list, the check-ins are mandatory'|transloco}}</span>
      <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="center center">
        <span dir="auto" fxLayout="row" fxLayoutAlign="center center" class="header-text regular"
          fxFlex="50">{{'country'|transloco}}</span>
        <span dir="auto" fxLayout="row" fxLayoutAlign="center center" class="header-text regular"
          fxFlex="50">{{'Evacuation Alert'|transloco}}</span>
      </div>
      <div fxLayout="column">
        <div fxLayout="row" fxLayoutGap="10px" *ngFor="let country of data">
          <span fxLayout="column" fxLayoutAlign="start start" class="country-container" fxFlex="50">
            <span class="country-text">{{country.country |jobTitle}}</span>
          </span>
          <span fxLayout="column" fxLayoutAlign="start center" class="country-container" fxFlex="50">
            <span
              class="country-text warning regular">{{ country.evacuationAlertLevel ? country.evacuationAlertLevel.split(':')[1] : "-"}}</span>
          </span>
        </div>
      </div>
    </div>
  </mat-dialog-content>
</div>
